/**
 * The tab's high-resolution timestamp counter: the last stamp newHRTimestamp (./timestamp) gave.
 * It lives in sessionStorage (per tab), or in memory where there is none.
 *
 * OWA-1083: kept apart from ./timestamp so code that only reads the counter (lib/pendingRows,
 * which keeps dispatched saves in dispatch order) does not depend on the clock module, which
 * many tests replace.
 */

const memory: {hrt: number} = {hrt: 0};

/** The last stamp this tab's counter gave (0 when it has given none). */
export function readHRCounter(): number {
    const last = typeof sessionStorage !== 'undefined'
        ? Number.parseFloat(sessionStorage.getItem('hrt') || '0')
        : memory.hrt;
    return Number.isFinite(last) ? last : 0;
}

/** Record `stamp` as the last stamp this tab's counter gave. */
export function writeHRCounter(stamp: number): void {
    if (typeof sessionStorage !== 'undefined') sessionStorage.setItem('hrt', `${stamp}`);
    else memory.hrt = stamp;
}
